import type {
  ContractorsListResponse,
  ContractorsListParams,
} from "@onsemble/shared/types/internal";
import { TanstackError } from "../client";

/**
 * Fetch contractor organizations.
 *
 * Supports optional search/pagination params:
 *   - q: fuzzy name search (Clerk)
 *   - hajocaCustomerId: exact lookup by Hajoca customer ID (Supabase-resolved)
 *   - limit / offset: pagination
 */
export async function getContractors(
  params: ContractorsListParams = {}
): Promise<ContractorsListResponse> {
  const search = new URLSearchParams();
  if (params.q) search.set("q", params.q);
  if (params.hajocaCustomerId) search.set("hajocaCustomerId", params.hajocaCustomerId);
  if (params.limit != null) search.set("limit", String(params.limit));
  if (params.offset != null) search.set("offset", String(params.offset));

  const qs = search.toString();
  const response = await fetch(
    `/api/internal/contractors${qs ? `?${qs}` : ""}`,
    {
      method: "GET",
      credentials: "include",
    }
  );

  const result: ContractorsListResponse = await response.json();

  if (!response.ok || !result.success) {
    throw new TanstackError(response.status, "Failed to fetch contractors");
  }

  return result;
}
